import imgJiva1 from "./img-jiva (1).webp";
import imgJiva2 from "./img-jiva (2).webp";
import imgJiva3 from "./img-jiva (3).webp";
import imgJiva4 from "./img-jiva (4).webp";
import imgJiva5 from "./img-jiva (5).webp";

const imgJiva = [imgJiva1, imgJiva2, imgJiva3, imgJiva4, imgJiva5];

export default imgJiva;
